import Api from '@/services/Index';

const storeLeaveSettingForm = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/settings/leave/of/absence', formData);
}

const getLeaveSettingForm = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/settings/leave/of/absence');
}

const getSemesterSettings = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/settings/semester');
}

const storeSemesterSettings = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/settings/semester', formData);
}

const getCourseSlotLogs = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/logs/course-slot-logs', config);
}

const placeResultExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/double/majors/place-result-excel-export', { responseType:'arraybuffer' })
}

const placeResultPublish = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/double/majors/place-result-publish')
}

const publishResultRegister = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/double/majors/publish-result-register')
}

const addToArchive = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/double/majors/add-archive')
}

export default {
    storeLeaveSettingForm,
    getLeaveSettingForm,
    getSemesterSettings,
    storeSemesterSettings,
    getCourseSlotLogs,
    placeResultExcelExport,
    placeResultPublish,
    publishResultRegister,
    addToArchive
}
